import parseDate from 'utils/parsers/parseDate';

const DAY = 86400000;

const addDays = (days, date) => {
  if (!Number.isSafeInteger(days)) return NaN;

  const parsed = Number.isFinite(date) ? date : parseDate(date);
  return days * DAY + parsed;
};

export default addDays;
